import { useMemo } from 'react';
import { Sponsor } from 'src/api/v2';

export type SponsorListType = { name: Sponsor };
export const useSponsorList = () => {
  const AllSponsorList: SponsorListType[] = useMemo(
    () => Object.values(Sponsor).map((sponsor) => ({ name: sponsor })),
    [],
  );

  function getSponsorList(Sponsors: Sponsor[]): SponsorListType[] {
    return Sponsors.map((sponsor) => ({ name: sponsor }));
  }

  return { AllSponsorList, getSponsorList };
};
